<template>
  <v-container style="min-height: 90dvh">
    
    <!-- <div class="text-center" v-if="loading">
        

        <v-overlay
          
          class="align-center justify-center"
        >
          <v-progress-circular
            color="primary"
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </div> -->
    
    <div>
      <v-row class="justify-space-between my-5 mx-auto newfont px-4" :class="{'w-50': lgAndUp, 'w-75': md}">
        <div :class="{'text-h6': xs}">
          🍿 Guess The <span class="bg-red-darken-1 py-0 text-white px-1 set-shadow"> Flick</span>
        </div>
        <div :class="{'text-caption': xs}" class="rounded float-end bg-black text-white elevation-6 text-subtitle-1 h-100 my-auto pa-1">
          🔥 <span class="mr-1">{{streak}}</span>
        </div>
      </v-row>
      
      <div>
        <v-row class="justify-center my-2">
          <VideoClip v-if="movieClip" :movieClip="movieClip" :getClip="get_a_clip" />
        </v-row>
        <v-row class="justify-center my-2">
          <v-col>
            <UserGuess v-if="movieClip" :movieClip="movieClip" :increment_streak="increment_streak" :reset_streak="reset_streak" :getClip="get_a_clip" class="mx-auto" :class="{'w-50': lgAndUp, 'w-75': md}"/>
          </v-col>
        </v-row>
      </div>
    </div>
    
  </v-container>
  <v-layout class="">
      <v-footer>
        <v-row class="justify-center my-5">
          <v-btn :block="smAndDown" variant="text" class="text-caption bg-green-accent-2 text-black" href="https://www.buymeacoffee.com/siddheshd17" target="_blank">
            ❤️ the game?, buy me cup of ☕ coffee
          </v-btn>

        </v-row>
      </v-footer>
    </v-layout>
</template>

<script>
import VideoClip from './components/VideoClip.vue';
import UserGuess from './components/UserGuess.vue';
import { getRandomMovieClip } from "@/services/supabaseService";

export default {
  name: 'App',

  components: {
    VideoClip,
    UserGuess
  },

  mounted(){
    this.get_a_clip();
  },

  computed: {
    md() {
      return this.$vuetify.display.md;
    },

    xs() {
      return this.$vuetify.display.xs;
    },

    lgAndUp() {
      return this.$vuetify.display.lgAndUp;
    },

    smAndDown() {
      return this.$vuetify.display.smAndDown;
    },

    get_height_width(){
      if(this.$vuetify.display.smAndUp){
        return 150
      }else{
        return 100
      }
    }
  },

  methods:{

    increment_streak(){
      this.streak += 1;
    },

    reset_streak(){
      this.streak = 0;
    },

    async get_a_clip(){
      this.loading = true;
      this.movieClip = await getRandomMovieClip();
      
      setTimeout(function(){this.loading = false;}.bind(this), 1500)
    }
  },

  data() {
    return {
      movieClip: null,
      loading: true,
      streak: 0
    };
  },
}
</script>

<style>
 /* @import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@600&display=swap');

  .newfont{
    font-family: 'Hind Siliguri', sans-serif !important;
    font-size: 32px;
  }*/

  .newfont{
    font-size: 32px;
  }

  .decoration{
    text-decoration-line: underline;
    text-decoration-style: wavy;
    text-decoration-color: black;
  }

  .set-shadow{
    -webkit-box-shadow: 9px 8px 0px -1px rgba(183,28,28,1);
    -moz-box-shadow: 9px 8px 0px -1px rgba(183,28,28,1);
    box-shadow: 9px 8px 0px -1px rgba(183,28,28,1);
  }
  
</style>